const TTL_MS = 7 * 24 * 60 * 60 * 1000;

export const getCacheKey = (kursId) => `kurs_themes_raw_${kursId}`;

// Синхронное чтение — для инициализации состояния без мигания загрузки
export const getThemesSync = (kursId) => {
  try {
    const cached = localStorage.getItem(getCacheKey(kursId));
    if (!cached) return null;
    const parsed = JSON.parse(cached);
    return parsed.data ?? null;
  } catch {
    return null;
  }
};

const pickFields = (item) => ({
  id: item.id,
  tartib: item.tartib,
  nomi_uz: item.nomi_uz,
  nomi_ru: item.nomi_ru,
  nomi_en: item.nomi_en,
  mrasmi_uz: item.mrasmi_uz,
  short_text_uz: item.short_text_uz,
  short_text_ru: item.short_text_ru,
  short_text_en: item.short_text_en,
  test_soni: item.test_soni,
  test_min_soni: item.test_min_soni,
  test_description_uz: item.test_description_uz,
  test_description_ru: item.test_description_ru,
  test_description_en: item.test_description_en,
  key_word_uz: item.key_word_uz,
  key_word_ru: item.key_word_ru,
  key_word_en: item.key_word_en,
  kurs: item.kurs,
});

const fetchAndStore = async (kursId) => {
  const res = await fetch(`https://api.aiassessment.uz/api/kurs-mavzulari/?kurs=${kursId}`);
  if (!res.ok) throw new Error('Ошибка сети: ' + res.status);
  const raw = await res.json();
  const data = raw.map(pickFields);
  localStorage.setItem(getCacheKey(kursId), JSON.stringify({ timestamp: Date.now(), data }));
  return data;
};

// Stale-while-revalidate:
// — если кеш есть и свежий (< TTL) → возвращает кеш мгновенно
// — если кеш есть, но устарел → возвращает кеш мгновенно + фоном обновляет
// — если кеша нет → ждёт сервер
export const getThemes = async (kursId) => {
  const cacheKey = getCacheKey(kursId);
  const cached = localStorage.getItem(cacheKey);

  if (cached) {
    try {
      const parsed = JSON.parse(cached);
      if (Date.now() - parsed.timestamp < TTL_MS) {
        // Свежий кеш — отдаём сразу
        return parsed.data;
      }
      // Устаревший кеш — отдаём сразу, фоном обновляем
      fetchAndStore(kursId).catch(() => {});
      return parsed.data;
    } catch {}
  }

  // Кеша нет — ждём сервер
  return fetchAndStore(kursId);
};
